import React from 'react';
import AutoScopeStyles from '../../../Common/Utilities/Decorators/AutoScopeStylesDecorator';
import NavigationStore from '../../Stores/NavigationStore';
import applyDecoratorsDoNotUseInNewCode from '../../Utilities/Decorators/ApplyDecorators';
import BreadCrumbsView from './BreadCrumbsView';

class PageTitleBarView extends React.Component {
    render(){
        const store = NavigationStore.getState();
        const currentPageTitle = store.currentPageTitle;
        const currentBreadcrumbs = store.currentBreadcrumbs;
        return (
            <nav>
                <BreadCrumbsView currentBreadcrumbs={ currentBreadcrumbs } currentPageTitle={ currentPageTitle }/>
                <div>
                    <div className="ecargo logo" data-env={ document.body.getAttribute('data-env') } />
                </div>
            </nav>
        )
    }
}

const withDecorators = applyDecoratorsDoNotUseInNewCode(AutoScopeStyles);

export default withDecorators(PageTitleBarView);
